import commonApi from './CommonApi.js';
var qs = require('querystring');

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/admin/contactAuditTrails/getAll', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getBatch: async (parameter) => {
		return await commonApi().get('/v1/admin/contactAuditTrails/getBatch', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	exportToExcelList: async (parameters) => {
		return await commonApi().get('/v1/admin/contactAuditTrails/exportToExcelList',
			//{ params: parameters, responseType: 'blob' }
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				var fileName = 'NNANEPChangesStatistics.xlsx';
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
}